export const TableRowsNames = {
  PHOTO: 'photo',
  AGE: 'age',
  SENIORITY: 'seniority',
  LOCATION: 'location',
  MUST_HAVE: 'must_have',
  NICE_TO_HAVE: 'nice_to_have',
  CURRENT_GLOBAL_COMPENSATION: 'current_global_compensation',
  DESIRED_GLOBAL_COMPENSATION: 'desired_global_compensation',
  COMPANY: 'company',
  NON_COMPETE_AGREEMENT: 'non_compete_agreement',
  NOTICE_PERIOD: 'notice_period',
  OTHER_SELECTIONS: 'other_selections',
  MOTIVATION: 'motivation',
  SUMMARY: 'summary',
};

const TableRowsDefault = [
  { id: TableRowsNames.PHOTO, hasVisibilityAction: false },
  { id: TableRowsNames.COMPANY, hasVisibilityAction: true },
  { id: TableRowsNames.AGE, hasVisibilityAction: true },
  { id: TableRowsNames.SENIORITY, hasVisibilityAction: true },
  { id: TableRowsNames.LOCATION, hasVisibilityAction: true },
  { id: TableRowsNames.MUST_HAVE, hasVisibilityAction: true },
  { id: TableRowsNames.NICE_TO_HAVE, hasVisibilityAction: true },
  { id: TableRowsNames.NOTICE_PERIOD, hasVisibilityAction: true },
  { id: TableRowsNames.NON_COMPETE_AGREEMENT, hasVisibilityAction: true },
  { id: TableRowsNames.CURRENT_GLOBAL_COMPENSATION, hasVisibilityAction: true },
  { id: TableRowsNames.DESIRED_GLOBAL_COMPENSATION, hasVisibilityAction: true },
  { id: TableRowsNames.OTHER_SELECTIONS, hasVisibilityAction: true },
  { id: TableRowsNames.MOTIVATION, hasVisibilityAction: true },
  { id: TableRowsNames.SUMMARY, hasVisibilityAction: true },
];

export const TableRowsWithoutCompensation = TableRowsDefault.filter(
  row =>
    row.id !== TableRowsNames.CURRENT_GLOBAL_COMPENSATION &&
    row.id !== TableRowsNames.DESIRED_GLOBAL_COMPENSATION,
);

export const TABLE_ROWS_NAMES_LIST_WITHOUT_COMPENSATION =
  TableRowsWithoutCompensation.map(row => row.id);

export const TABLE_ROWS_NAMES_LIST = Object.values(TableRowsNames);

export const TABLE_ROWS_HIDDEN_IN_MARKETING_JOBS = [
  TableRowsNames.MUST_HAVE,
  TableRowsNames.NICE_TO_HAVE,
];

export const TableRows = TableRowsDefault;
